<template>
  <panel>
    <loader :loading="loading"/>
    <canvas :id="identifier" width="400" height="100"></canvas>
  </panel>
</template>


<script>

  import Chart from 'chart.js'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'

  export default {
    props: {
      identifier: {
        type: String,
        required: true
      },
      data: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    mounted () {
      var element = document.getElementById(this.identifier)
      var chart = new Chart(element, {
        options: {
          legend: {
            display: true
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        },
        type: 'line',
        data: {
          labels: this.labels(),
          datasets: this.datasets()
        }
      })
      chart.chart
    },
    methods: {
      labels () {
        return this.data.labels
      },
      datasets () {
        let datasets = []
        let colors = ['#52B4E7', '#A3EB57', '#FCCA5E', '#86CCFF', '#E481C9', '#EFDE43', '#8DB8C6', '#C9C8A6', '#39BACD', '#D0EB43', '#A093FC']

        this.data.lines.forEach(function (line, index) {
          datasets.push({
            label: line.identifier,
            fill: false,
            lineTension: 0,
            borderColor: colors[index],
            borderWidth: 2,
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: '#fff',
            pointBackgroundColor: colors[index],
            pointHoverBackgroundColor: colors[index],
            pointHoverBorderColor: '#fff',
            pointRadius: 4,
            pointHoverRadius: 6,
            pointBorderWidth: 0,
            pointHoverBorderWidth: 0,
            pointHitRadius: 6,
            data: line.values,
            spanGaps: false
          })
        })

        return datasets
      }
    },
    components: {
      Panel,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// LineChart.vue?b37f1da8